import clsx from "clsx";
import { useEffect, useState } from "react";
import { Socials } from "../../components";
import BurgerItem from "./MobileMenuItem";
import LangSwitcher from "../LangSwitcher";
import style from "./style.module.scss";

function BurgerMenu({
  socials,
  contactLink,
  categoriesLink,
  burgerMenuOpen,
  categories,
  langs,
}) {
  const [menuOpenId, setMenuOpenId] = useState(0);

  useEffect(() => {
    if (burgerMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      setMenuOpenId(0);
      document.body.style.overflow = "visible";
    }
  }, [burgerMenuOpen]);

  return (
    <div className={clsx(burgerMenuOpen && style.open, style.burgerMenu)}>
      <div className={style.content}>
        {categories &&
          Object.values(categories).map((category) => (
            <BurgerItem
              key={category.cat_ID}
              category={category}
              expand={menuOpenId === category.cat_ID}
              setMenuOpenId={setMenuOpenId}
            />
          ))}

        {categoriesLink && (
          <a href={categoriesLink.url}>{categoriesLink.label}</a>
        )}
      </div>

      <div className={style.footer}>
        <div className={style.content}>
          {contactLink && (
            <a className={style.contactLink} href={contactLink.url}>
              {contactLink.label}
            </a>
          )}

          <div className={style.bottom}>
            <LangSwitcher langs={langs} />

            <Socials socials={socials} className={style.socialNetworks} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BurgerMenu;
